import React from 'react';
import PropTypes from 'prop-types';
import { KeyboardDatePicker } from '@material-ui/pickers';
import classnames from 'classnames';
import { FormLabel } from 'components/FormTexts';
import { ReactComponent as CalendarIcon } from 'assets/icons/ic-calendar-day.svg';

import * as Styled from './DatePicker.styled';

// To use this component a utils provider must be placed before. Example - <MuiPickersUtilsProvider libInstance={moment} utils={MomentUtils}>
// Checkout the documentation here - https://material-ui-pickers.dev/getting-started/usage
const DatePicker = (props) => {
  const {
    onChange,
    value,
    variant,
    className,
    classes,
    label,
    disabled,
    error,
    labelId,
    onBlur,
    ...passThroughProps
  } = props;

  const inputClasses = Styled.useInputComponentStyles();

  const inputAdornmentClasses = Styled.useInputAdornmentStyles();

  const keyboardButtonClasses = Styled.useKeyboardButtonStyles({
    error,
    disabled,
  });
  const errorTextClasses = Styled.useErrorMessageStyles();

  return (
    <Styled.RootComponent
      className={classnames(classes.root, className)}
      disabled={disabled}>
      {label && (
        <FormLabel htmlFor={labelId} className={classes.label}>
          {label}
        </FormLabel>
      )}
      <KeyboardDatePicker
        variant={variant}
        value={value}
        onChange={onChange}
        disabled={disabled}
        error={!!error}
        autoOk={true}
        helperText={typeof error === 'string' ? error : null}
        invalidLabel={'Invalid date'}
        FormHelperTextProps={{
          classes: errorTextClasses,
        }}
        InputProps={{
          classes: inputClasses,
          disableUnderline: true,
          id: labelId,
          onBlur: onBlur,
        }}
        InputAdornmentProps={{
          classes: inputAdornmentClasses,
        }}
        keyboardIcon={<CalendarIcon />}
        KeyboardButtonProps={{
          classes: keyboardButtonClasses,
        }}
        className={classes.datePicker}
        {...passThroughProps}
      />
    </Styled.RootComponent>
  );
};

DatePicker.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.shape({
    root: PropTypes.string,
    label: PropTypes.string,
    datePicker: PropTypes.string,
  }),
  label: PropTypes.string,
  error: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  value: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  placeholder: PropTypes.string,
  variant: PropTypes.oneOf(['dialog', 'inline', 'static']),
  format: PropTypes.string,
  /* Message to be displayed when the date cannot be parsed. */
  invalidDateMessage: PropTypes.string,
  minDate: PropTypes.object,
  maxDate: PropTypes.object,
  disabled: PropTypes.bool,
  disablePast: PropTypes.bool,
  disableFuture: PropTypes.bool,
  labelId: PropTypes.string,
  // Refer here for pass through props - https://material-ui-pickers.dev/api/KeyboardDatePicker
};

DatePicker.defaultProps = {
  placeholder: 'DD/MM/YYYY',
  label: '',
  className: '',
  onChange: () => {},
  variant: 'inline',
  classes: {
    root: '',
    label: '',
    datePicker: '',
  },
  disabled: false,
  format: 'DD/MM/YYYY',
  disablePast: false,
  disableFuture: false,
  labelId: '',
  value: null,
  onBlur: () => {},
};

export default DatePicker;
